import { Autocomplete } from '@material-ui/lab';
import { Grid, TextField } from '@mui/material';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { handleSetCompany, handleSetStation } from 'redux/actions/brands/brandsAction_V2';
import { validateObject } from '../../helpers/validateObject';

export const BrandsInputs = () => {
  const { companiesList } = useSelector(({companies}) => companies);
  const { company, station } = useSelector(({brandsReducer}) => brandsReducer);
  const dispatch = useDispatch();

  const checkForData = (value) => {
    return validateObject(value) ? value : null;
  }

  const handleChangeCompany = (e, v) => {
    const value = v ? v : null;
    dispatch(handleSetCompany(value));
  }
  
  const handleStationChange = (e, v) => {
    const value = v ? v : null;
    dispatch(handleSetStation(value));
  }

  useEffect(() => {
    dispatch(handleSetStation({}));
  }, [company]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6}>
        <Autocomplete
          filterSelectedOptions
          options={companiesList}
          value={checkForData(company)}
          getOptionLabel={(option) =>
            (option.label ? option.label : option.name) || ""
          }
          renderInput={(params) => (
            <TextField
              {...params}
              name="company"
              value={company}
              label="Buscar por empresa"
              variant="outlined"
            />
          )}
          fullWidth
          onChange={(e, v) => handleChangeCompany(e, v)}
          noOptionsText="No se encuentra la Empresa"
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <Autocomplete
          filterSelectedOptions
          options={company?.stations || []}
          value={checkForData(station)}
          getOptionLabel={(option) =>
            (option.label ? option.label : option.name) || ""
          }
          renderInput={(params) => (
            <TextField
              {...params}
              name="station"
              value={station}
              label="Buscar por planta"
              variant="outlined"
            />
          )}
          fullWidth
          onChange={(e, v) => handleStationChange(e, v)}
          noOptionsText={"No hay resultados de Plantas"}
        />
      </Grid>
    </Grid>
  )
}
